import { useMemo } from 'react';

import { useExperimentFlag } from '@zenbusiness/application-commons-experiments';

import { ENABLE_EIN_V3_JOURNEY } from '#client/constants/experimentsFlags';

export const SERVICE_TO_FLAG_MAPPING = {
  ein_creation: ENABLE_EIN_V3_JOURNEY
};

export function useCheckoutServiceFlags() {
  const einV3JourneyEnabled = useExperimentFlag(ENABLE_EIN_V3_JOURNEY, false);

  return useMemo(() => {
    const flags = {};
    Object.entries(SERVICE_TO_FLAG_MAPPING).forEach(([serviceCode, flagKey]) => {
      if (flagKey === ENABLE_EIN_V3_JOURNEY) {
        flags[serviceCode] = einV3JourneyEnabled;
      }
    });
    return flags;
  }, [einV3JourneyEnabled]);
}
